import axios from "axios";
import { Form, Popup, Toolbar } from "devextreme-react";
import {
  AsyncRule,
  ButtonItem,
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import DataSource from "devextreme/data/data_source";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { pathEnt, pathEntList, reasonL, reasonLList } from "./data";

export default function JoinLeaveInformation() {
  const [joinLeaveInfoDataSource, setJoinLeaveInfoDataSource] = useState(null);
  const [pathEntDataSource, setPathEntDataSource] = useState(null);
  const [reasonLDataSource, setReasonLDataSource] = useState(null);

  const [popupVisible, setPopupVisible] = useState(false);

  const userInfo = useSelector((state) => state.userInfo);

  const joinLeaveInfoFormRef = useRef(null);

  useEffect(async () => {
    setDataSource();

    setPathEntDataSource(
      new DataSource({
        store: { data: pathEntList, type: "array", key: "id" },
      })
    );

    setReasonLDataSource(
      new DataSource({
        store: reasonLList,
        type: "array",
        key: "id",
      })
    );
  }, []);

  const displayPathEntExpr = (item) => {
    if (item) {
      if (item == "9" || item.id == "9") {
        if (joinLeaveInfoDataSource.otrPathEnt) {
          return joinLeaveInfoDataSource.otrPathEnt;
        } else {
          return item.name;
        }
      } else {
        return item.name;
      }
    }
  };

  const displayReasonLExpr = (item) => {
    if (item) {
      if (item == "9" || item.id == "9") {
        if (joinLeaveInfoDataSource.otrReasonL) {
          return joinLeaveInfoDataSource.otrReasonL;
        } else {
          return item.name;
        }
      } else {
        return item.name;
      }
    }
  };

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const newPathEnt = {
      id: "9",
      name: args.text,
    };

    args.customItem = pathEntDataSource
      .store()
      .insert(newPathEnt)
      .then(() => {
        pathEntDataSource.load();
      })
      .then(() => newPathEnt)
      .catch((error) => {
        throw error;
      });
  };

  const onCustomReasonLItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const newReasonL = {
      id: "9",
      name: args.text,
    };

    args.customItem = reasonLDataSource
      .store()
      .insert(newReasonL)
      .then(() => {
        reasonLDataSource.load();
      })
      .then(() => newReasonL)
      .catch((error) => {
        throw error;
      });
  };

  const validationCallback = async (params) => {
    if (params.value && params.value != "") {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee/hasEmployee/${params.value}`
      );

      return result.data.nEmployeeNo > 0;
    } else {
      return null;
    }
  };

  const onClick = async () => {
    if (joinLeaveInfoFormRef.current.instance.validate().isValid) {
      let otrPathEnt = null;
      let otrReasonL = null;

      if (joinLeaveInfoDataSource.pathEnt == "9") {
        const otherItem = pathEntDataSource
          .items()
          .find((item) => item.id == "9");

        otrPathEnt = otherItem
          ? otherItem.name
          : joinLeaveInfoDataSource.otrPathEnt;
      }

      if (joinLeaveInfoDataSource.reasonL == "9") {
        const otherItem = reasonLDataSource
          .items()
          .find((item) => item.id == "9");

        otrReasonL = otherItem
          ? otherItem.name
          : joinLeaveInfoDataSource.otrReasonL;
      }

      await axios.put(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee/${joinLeaveInfoDataSource.employeeNo}`,
        {
          ...joinLeaveInfoDataSource,
          otrPathEnt: otrPathEnt,
          otrReasonL: otrReasonL,
        }
      );

      setPopupVisible(false);

      setDataSource();
    }
  };

  const setDataSource = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/joinLvInfo/${userInfo.employeeNo}`
    );

    setJoinLeaveInfoDataSource(result.data);
  };

  const onHiding = () => {
    setPopupVisible(false);
  };

  return (
    <React.Fragment>
      <Toolbar>
        <Item
          location="after"
          locateInMenu={"auto"}
          widget="dxButton"
          options={{
            icon: joinLeaveInfoDataSource ? "edit" : "plus",
            onClick: () => {
              setPopupVisible(true);
            },
          }}
        />
      </Toolbar>
      {joinLeaveInfoDataSource && (
        <div>
          <div className="tabpanel-item">
            <div>
              <table>
                <tbody>
                  <tr>
                    {/* <th>입사일:</th> */}
                    <th>Employment Date:</th>
                    <td>
                      <b>{joinLeaveInfoDataSource.startDate}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>입사경로:</th> */}
                    <th>Employment Path:</th>
                    <td>
                      <b>
                        {joinLeaveInfoDataSource.pathEnt == "9"
                          ? joinLeaveInfoDataSource.otrPathEnt
                          : pathEnt[joinLeaveInfoDataSource.pathEnt]}
                      </b>
                    </td>
                  </tr>
                  {joinLeaveInfoDataSource.prevEmployeeNo && (
                    <tr>
                      {/* <th>이전사번:</th> */}
                      <th>Previsous Employee ID:</th>
                      <td>
                        <b>{joinLeaveInfoDataSource.prevEmployeeNo}</b>
                      </td>
                    </tr>
                  )}
                  {joinLeaveInfoDataSource.depDate && (
                    <tr>
                      {/* <th>퇴사일:</th> */}
                      <th>Resignation Date:</th>
                      <td>
                        <b>{joinLeaveInfoDataSource.depDate}</b>
                      </td>
                    </tr>
                  )}
                  {joinLeaveInfoDataSource.reasonL && (
                    <tr>
                      {/* <th>퇴사사유:</th> */}
                      <th>Reason for Resignation:</th>
                      <td>
                        <b>
                          {joinLeaveInfoDataSource.reasonL == "9"
                            ? joinLeaveInfoDataSource.otrReasonL
                            : reasonL[joinLeaveInfoDataSource.reasonL]}
                        </b>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <Popup
        visible={popupVisible}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        width={1200}
        height="auto"
        // title="입/퇴사 정보"
        title="EMPLOYMENT/RESIGNATION INFO."
        onHiding={onHiding}
      >
        <Form
          ref={joinLeaveInfoFormRef}
          labelMode="outside"
          showCloseButton={false}
          labelLocation={"top"}
          minColWidth={300}
          colCount={4}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="joinLeaveInfo"
          height={"100%"}
          formData={joinLeaveInfoDataSource}
        >
          <SimpleItem
            dataField={"startDate"}
            editorType="dxDateBox"
            editorOptions={{
              type: "date",
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
            }}
          >
            {/* <Label text={"입사일"} /> */}
            <Label text={"Employment Date"} />
            <RequiredRule message={"Employment date is required."} />
          </SimpleItem>
          <SimpleItem
            dataField={"pathEnt"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: pathEntDataSource,
              valueExpr: "id",
              displayExpr: displayPathEntExpr,
              showClearButton: true,
              placeholder: "직접입력가능",
              acceptCustomValue: true,
              onCustomItemCreating: onCustomItemCreating,
            }}
          >
            {/* <Label text={"입사경로"} /> */}
            <Label text={"Employment Path"} />
          </SimpleItem>
          <SimpleItem
            dataField={"prevEmployeeNo"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            {/* <Label text={"이전사번"} /> */}
            <Label text={"Previous Employee ID"} />
            <AsyncRule
              message={"There is no previous employee no."}
              validationCallback={validationCallback}
            />
          </SimpleItem>
          <EmptyItem />
          <SimpleItem
            dataField={"depDate"}
            editorType="dxDateBox"
            editorOptions={{
              type: "date",
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
            }}
          >
            {/* <Label text={"퇴사일"} /> */}
            <Label text={"Resignation Date"} />
          </SimpleItem>
          <SimpleItem
            dataField={"reasonL"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: reasonLDataSource,
              valueExpr: "id",
              displayExpr: displayReasonLExpr,
              showClearButton: true,
              placeholder: "직접입력가능",
              acceptCustomValue: true,
              onCustomItemCreating: onCustomReasonLItemCreating,
            }}
            colSpan={3}
          >
            {/* <Label text={"퇴사사유"} /> */}
            <Label text={"Reason for Resignation"} />
          </SimpleItem>
          <ButtonItem
            horizontalAlignment={"right"}
            buttonOptions={{
              text: "SAVE",
              type: "normal",
              stylingMode: "text",
              onClick: onClick,
            }}
            colSpan={4}
          />
        </Form>
      </Popup>
    </React.Fragment>
  );
}
